export default __webpack_public_path__ + "assets/front/scss/error.890628565164f5535c78c0dd0f906f78.css";